function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScNotifications = function SvgScNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "M14 19a2 2 0 1 1-4 0m3-14.917V3a1 1 0 1 0-2 0v1.083m2 0a6.04 6.04 0 0 0-2 0m2 0c2.838.476 5 2.944 5 5.917 0 2.761.007 5.015 1.273 7.546A1.004 1.004 0 0 1 18.382 19H5.618c-.743 0-1.223-.79-.89-1.454C5.992 15.015 6 12.76 6 10a6.002 6.002 0 0 1 5-5.917",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScNotifications;